export default {
	UPDATE_ACTIVE_ORGANISATION(state, organisation) {
    localStorage.setItem('last_organisation', JSON.stringify(organisation))
    state.organisation = organisation
  },
  UPDATE_ORGANISATION_USER(state, user) {
    localStorage.setItem('last_organisation_user', JSON.stringify(user))
    state.organisation_user = user
  },
  UPDATE_AVAILABLE_REPORTS(state, results) {
    state.dpr_reports = results
  },
}